// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"5895":"21b23acf","6093":"3e4cd385"}[chunkId] + ".css";
};